// Keep these tiers equal to _breakpoints.scss
export const SCANNER_RESOLUTION_WIDTH = 500;
// The compact layout's widest screen, checked up to 288x288; it covers the WS501, 230x230 at devicePixelRatio 2
// (unverified). Keep it below the scanner tier
export const WEARABLE_RESOLUTION_WIDTH = 288;
const BREAKPOINT_SCANNER = `${SCANNER_RESOLUTION_WIDTH}px`;
const BREAKPOINT_WEARABLE = `${WEARABLE_RESOLUTION_WIDTH}px`;
const BREAKPOINT_THIN_CLIENT = '720px';
const BREAKPOINT_LAPTOP = '1480px'

export const responsiveProps = {
    titleSize: {
        default: "b500",
        [BREAKPOINT_THIN_CLIENT]: "b500",
        [BREAKPOINT_SCANNER]: "b400"
    },
    footerItemText: {
        default: "b300",
        [BREAKPOINT_SCANNER]: "b200"
    },
    isScanner: {
        default: false,
        [BREAKPOINT_SCANNER]: true
    },
    inputBarSize: {
        default: "xlarge",
        [BREAKPOINT_SCANNER]: "small"
    },
    buttonSize: {
        default: "medium",
        [BREAKPOINT_SCANNER]: "small"
    },
    alertSize: {
        default: "large",
        [BREAKPOINT_SCANNER]: "large"
    },
    buttonGroupSize: {
        default: "medium",
        [BREAKPOINT_SCANNER]: "small"
    },
    // '400' is Meridian's Column default; '100' its smallest, 2px, leaves the tallest unload result, a refused
    // 34-character scan, 13px to spare at 230x230, the WS501's screen (unverified), where 16px leaves none
    columnSpacing: {
        default: "400",
        [BREAKPOINT_WEARABLE]: "100"
    }
}

// For max-height queries; apart from responsiveProps, which some screens also query by height
export const responsiveHeightProps = {
    isShortViewport: {
        default: false,
        // With the scan icon, the tallest unload result, a refused 34-character scan, needs up to 346px at widths up
        // to 500px; 420 leaves room
        '420px': true
    }
}